import SubLandingBanner from './component'
export default SubLandingBanner
